import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import { MembershipFragmentDoc } from '../CustomerAsLawyer/CustomerAsLawyer.queries'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type CustomerForProfileQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']
}>

export type CustomerForProfileQuery = {
  __typename?: 'Query'
  customer: {
    __typename?: 'Customer'
    id: number
    dateOfBirth?: any | null
    email: string
    firstName?: string | null
    gender?: Types.Gender | null
    lastName?: string | null
    mobilePhone?: string | null
    phone?: string | null
    profilePictureUrl?: string | null
    address?: {
      __typename?: 'OptionalAddress'
      street?: string | null
      city?: string | null
      zip?: string | null
      country?: string | null
    } | null
    membership?: {
      __typename?: 'Membership'
      uuid: string
      membershipNumber: string
      activatedAt: any
      startsAt: any
      state: Types.MembershipState
      membershipTypeUid: string
      lawyerId: number
      advancedFrom?: { __typename?: 'Membership'; uuid: string } | null
      product: {
        __typename?: 'Product'
        id: number
        name: string
        type: string
        upgradesTo?: Array<number> | null
      }
    } | null
    chat: {
      __typename?: 'MessagesCollection'
      items: Array<{
        __typename?: 'Message'
        id: number
        type: Types.MessageType
        documents?: Array<
          | {
              __typename?: 'CustomerDocument'
              checked?: boolean | null
              id: number
              name: string
              createdAt: any
              fileFormat?: string | null
              fileUrl: string
            }
          | {
              __typename?: 'LawyerDocument'
              id: number
              name: string
              createdAt: any
              fileFormat?: string | null
              fileUrl: string
            }
        > | null
      }>
    }
    purchases: {
      __typename?: 'PurchasesCollection'
      last?: {
        __typename?: 'Purchase'
        id: number
        product?: {
          __typename?: 'Product'
          id: number
          name: string
          type: string
          upgradesTo?: Array<number> | null
        } | null
      } | null
    }
    note?: { __typename?: 'CustomerNote'; id: number; note: string } | null
  }
}

export const CustomerForProfileDocument = gql`
  query CustomerForProfile($id: Int!) {
    customer(id: $id) {
      id
      dateOfBirth
      email
      firstName
      gender
      lastName
      mobilePhone
      phone
      profilePictureUrl
      address {
        street
        city
        zip
        country
      }
      membership {
        ...Membership
      }
      chat(filters: { messageType: { in: [Question, Answer, Information] } }) {
        items {
          id
          type
          documents {
            id
            name
            createdAt
            fileFormat
            fileUrl
            ... on CustomerDocument {
              checked
            }
          }
        }
      }
      purchases(filters: { isArchived: { not_equals: true } }, sorts: { createdAt: ASC }) {
        last {
          id
          product {
            id
            name
            type
            upgradesTo
          }
        }
      }
      note {
        id
        note
      }
    }
  }
  ${MembershipFragmentDoc}
`
export function useCustomerForProfileQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CustomerForProfileQuery,
    CustomerForProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<CustomerForProfileQuery, CustomerForProfileQueryVariables>(
    CustomerForProfileDocument,
    options
  )
}
export function useCustomerForProfileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CustomerForProfileQuery,
    CustomerForProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<CustomerForProfileQuery, CustomerForProfileQueryVariables>(
    CustomerForProfileDocument,
    options
  )
}
export type CustomerForProfileQueryHookResult = ReturnType<typeof useCustomerForProfileQuery>
export type CustomerForProfileLazyQueryHookResult = ReturnType<
  typeof useCustomerForProfileLazyQuery
>
export type CustomerForProfileQueryResult = ApolloReactCommon.QueryResult<
  CustomerForProfileQuery,
  CustomerForProfileQueryVariables
>
export function refetchCustomerForProfileQuery(variables?: CustomerForProfileQueryVariables) {
  return { query: CustomerForProfileDocument, variables: variables }
}
